<template>
    <div class="wiki-image-picker">
        <div v-if="modelValue" class="wiki-image-selected">
            <div class="image-wrapper">
                <ExternalImage :src="modelValue" />
            </div>
            <Bttn
                ref="searchButton"
                class="wiki-change outlined slim"
                @click="clear"
            >
                Change image
            </Bttn>
        </div>
        <div
            v-else
            :class="{
                'wiki-image-options': true,
                searching: searching,
            }"
        >
            <div v-if="images.length && !consentStore.externalAllowed">
                <Bttn @click="consentStore.set('external')"
                    >Allow external content to see Wikipedia images</Bttn
                >
            </div>
            <template v-else>
                <img
                    v-for="[full, width, thumb] in images"
                    :key="full"
                    class="wiki-option"
                    :src="thumb"
                    :width="Math.min(width, 300)"
                    @click="select(thumb)"
                />
            </template>
            <br />
            <span v-if="!searching && !images.length">
                No relevant images found.
            </span>
        </div>
    </div>
</template>
<script>
import { fetch, handleResponse } from "js/lib/server.js";
import { useConsentStore } from "js/stores/consentStore.js";
import ExternalImage from "js/components/common/ExternalImage.vue";

export default {
    name: "WikiImagePicker",
    components: {
        ExternalImage,
    },
    props: {
        id: {
            type: String,
            default: "wiki-image-picker",
        },
        modelValue: {
            type: String,
            default: "",
        },
        geo: {
            type: Object,
            default: null,
        },
    },
    emits: ["update:modelValue"],
    data() {
        return {
            searching: true,
            images: [],
            picked: null,
            consentStore: useConsentStore(),
        };
    },
    watch: {
        geo() {
            this.loadImages();
        },
    },
    mounted() {
        this.loadImages();
    },
    methods: {
        async loadImages() {
            if (!this.geo) {
                this.searching = false;
                return;
            }
            if (!this.geo.wiki) {
                this.loadMoreImages();
                return;
            }
            const [lang, title] = this.geo.wiki.split(":");
            fetch("/api/utils/wiki-images/", {
                params: {
                    lang,
                    title,
                },
            })
                .then(handleResponse)
                .then((images) => {
                    this.images = images;
                    this.searching = false;

                    if (images.length <= 5) {
                        this.loadMoreImages();
                    }
                });
        },
        loadMoreImages() {
            const lang = "en";
            let title = this.geo.name || this.geo.city;
            if (this.geo.wiki === `${lang}:${title}`) {
                return;
            }
            title = title.replaceAll("Metropolitan Area", "");
            console.log("fetching more images for " + title);
            fetch("/api/utils/wiki-images/", {
                params: {
                    lang,
                    title,
                },
            })
                .then(handleResponse)
                .then((images) => {
                    this.images = this.images.concat(images);
                });
            this.searching = false;
        },
        select(url) {
            this.$emit("update:modelValue", url);
        },
        clear() {
            this.$emit("update:modelValue", "");
            if (!this.images.length) {
                this.loadImages();
            }
        },
    },
};
</script>
